import React from "react";
import PostCards from "../components/PostCards";

const MasterList = () => {
  return <PostCards />;
};

export default MasterList;
